import { render, staticRenderFns } from "./WDDashboardSummaryRp.vue?vue&type=template&id=516f7bc2&scoped=true&"
import script from "./WDDashboardSummaryRp.vue?vue&type=script&lang=js&"
export * from "./WDDashboardSummaryRp.vue?vue&type=script&lang=js&"
import style0 from "./WDDashboardSummaryRp.vue?vue&type=style&index=0&id=516f7bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f7bc2",
  null
  
)

export default component.exports